
export const create = function(username, password){
  let basicAuthCredentials = btoa(username + ":" + password);
  return 'Basic ' + basicAuthCredentials;
};


export default{
  create
}



// WEBPACK FOOTER //
// ./src/utils/BasicAuthGenerator.js